import { skipToken } from '@reduxjs/toolkit/query';

import { api } from '~/redux/api/createApi';
import { RbacPermission } from '~/types/Rbac';

type Props = {
  permission?: RbacPermission;
};

export const usePermission = ({ permission }: Props) => {
  // `skipToken` rather than a `skip` flag: it keeps the arg honestly absent
  // instead of standing in an empty resource id that is not a real resource.
  const { data: permissionResponse, isFetching } =
    api.endpoints.checkPermission.useQuery(permission ?? skipToken);

  return {
    hasPermission: permission
      ? permissionResponse?.data?.attributes?.permission
      : true,
    isLoading: isFetching,
  };
};
